import React from "react";

// components
import Skeleton from "@/components/Skeleton";

// assets
import styles from "@/assets/styles/pages/location-single-page/location-single-page-components.module.scss";

const LocationSpaceCardLoading = () => {

  // renders

  return (
    <div className={styles["locl-location-page-space-card"]} data-testid="locl-space-card-loading">
      <div className={styles["locl-location-page-space-card__content"]}>
        <div className={styles["locl-location-page-space-card__carousel"]}>
          <Skeleton.Image className={styles["locl-location-page-space-card__loading__carousel"]}/>
        </div>
        <div className={styles["locl-location-page-space-card__info"]}>
          <div className={styles["locl-location-page-space-card__info-main"]}>
            <div
              className={styles["locl-location-page-space-card__name"]}
            >
              <Skeleton.Input className={styles["locl-location-page-space-card__loading__text"]} />
            </div>
          </div>
          <Skeleton.Input className={styles["locl-location-page-space-card__loading__text"]} />
        </div>
        <Skeleton.Input className={styles["locl-location-page-space-card__loading__dimensions"]} />
        <div className={styles["locl-location-page-space-card__footer"]}>
          <Skeleton.Input className={styles["locl-location-page-space-card__loading__button"]} />
          <Skeleton.Input className={styles["locl-location-page-space-card__loading__button"]} />
        </div>
      </div>
    </div>
  )
}

export default LocationSpaceCardLoading;
